import _ from 'underscore';
import Backbone from 'backbone';

var PartnersCollection = Backbone.Collection.extend({
    model: Backbone.Model,

    url: function() {
        return '/api/v1/event/'+ this.eventId + '/partners';
    },

    initialize: function(options) {
        this.eventId = options.eventId;
    },

    parse: function(response) {
        var sponsors = _.isUndefined(response['event-partners'].sponsors) ? [] : (_.isArray(response['event-partners'].sponsors) ? response['event-partners'].sponsors: [response['event-partners'].sponsors]);
        var exhibitors = response['event-partners'].exhibitors;
        this.fetched = true;
        return sponsors.concat(exhibitors);
    }

});

export default PartnersCollection;

